export { default as Img200 } from './processed/200/ForgedinFire.jpg';
export { default as Img400 } from './processed/400/ForgedinFire.jpg';
export { default as Imgthumb } from './processed/thumb/ForgedinFire.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/ForgedinFire.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/ForgedinFire.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      252,
      38,
      36
    ],
    "_population": 3,
    "_hsl": [
      0.0015432098765432098,
      0.972972972972973,
      0.5647058823529412
    ]
  },
  "LightVibrant": {
    "_rgb": [
      244,
      204,
      132
    ],
    "_population": 1,
    "_hsl": [
      0.10714285714285715,
      0.8358208955223884,
      0.7372549019607844
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      127,
      40,
      9
    ],
    "_population": 142,
    "_hsl": [
      0.04378531073446327,
      0.8676470588235294,
      0.26666666666666666
    ]
  },
  "Muted": {
    "_rgb": [
      171,
      122,
      94
    ],
    "_population": 190,
    "_hsl": [
      0.060606060606060615,
      0.31428571428571417,
      0.5196078431372548
    ]
  },
  "LightMuted": {
    "_rgb": [
      204,
      176,
      159
    ],
    "_population": 23,
    "_hsl": [
      0.06296296296296293,
      0.30612244897959195,
      0.711764705882353
    ]
  },
  "DarkMuted": {
    "_rgb": [
      92,
      59,
      53
    ],
    "_population": 40,
    "_hsl": [
      0.025641025641025644,
      0.2689655172413793,
      0.28431372549019607
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/ForgedinFire.js